import type { FeatureModule } from '@/core/platform/features/FeatureModule';
import { FeedbackEnvConfig } from './core/FeedbackEnvConfig';

export class FeedbackFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'feedback',
    envSchema: FeedbackEnvConfig.getSchema(),
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return FeedbackFeatureModule.definition;
  }
}
